import BaseObject from "@shared/BaseObject.js";

export default class BaseToolShareSettings extends BaseObject {
	isEnabled: boolean = true

	constructor(options = {}) {
		super(options);
		this.applyOptions(options)
	}
}
